import { ENEMY } from '../config/config';
import type { World } from '../game/world';
import { C } from '../gfx/palette';
import type { Renderer } from '../gfx/renderer';
import { Enemy } from './enemy';

/**
 * Grub — the basic patroller. Walks in a straight line, reverses at walls, and happily
 * marches off ledges. Stomping it flattens it.
 */
export class Grub extends Enemy {
  private anim = 0;

  constructor(x: number, y: number) {
    super(x, y + 2, 16, 14);
    this.speed = ENEMY.grubSpeed;
    this.turnAtEdge = false;
  }

  protected override get particleColor(): string {
    return C.grub;
  }

  override update(dt: number, world: World): void {
    if (this.updateTumble(dt, world)) return;
    if (this.squash > 0) {
      this.squash -= dt;
      if (this.squash <= 0) this.alive = false;
      return;
    }
    this.anim += dt;
    this.patrol(dt, world);
    if (this.y > world.map.pixelH + 48) this.alive = false;
  }

  override onStomp(world: World): boolean {
    if (this.dying) return false;
    this.dying = true;
    this.squash = ENEMY.grubSquashTime;
    this.vx = 0;
    this.vy = 0;
    world.addScore(world.nextStompScore(), this.centerX, this.y);
    world.sfx('stomp');
    world.particles.puff(this.centerX, this.bottom - 3, C.grubBelly, 6);
    return true;
  }

  override onOrb(world: World): boolean {
    this.defeatFlip(world, 200, this.facing);
    return true;
  }

  override onShellHit(world: World, dir: number): void {
    this.defeatFlip(world, world.nextShellScore(), dir);
  }

  override onBlockBump(world: World): void {
    this.defeatFlip(world, 200, this.facing);
  }

  override onPrism(world: World): void {
    this.defeatFlip(world, 200, this.facing);
  }

  override draw(r: Renderer): void {
    if (this.tumbling) {
      this.drawTumbling(r, 'grub.0');
      return;
    }
    if (this.squash > 0) {
      r.sprite('grub.squash', this.x, this.y);
      return;
    }
    const frame = Math.floor(this.anim * 6) % 2;
    r.sprite(`grub.${frame}`, this.x, this.y, this.facing > 0);
  }
}
